/**
 * Copyright IBM Corp. 2022, 2026
 */

import type { SidebarLinkItemProps, SidebarMenuItemProps } from '../types'

export function isMenuType(
	item: SidebarLinkItemProps | SidebarMenuItemProps,
): item is SidebarMenuItemProps {
	if (item) {
		return 'title' in item
	}
}

export function isLinkType(
	item: SidebarLinkItemProps | SidebarMenuItemProps,
): item is SidebarLinkItemProps {
	if (item) {
		return 'href' in item
	}
}
